<template>
  <div class="page">
    <div class="page-title__wrap-header">
      <h1>{{ title }}</h1>
    </div>
    <div class="tesIframe page-block__component">
      <vue-iframe
        v-if="!loading"
        :src="src"
        allow="camera *; geolocation *; microphone *; autoplay *"
        frame-id="my-ifram"
        @iframe-load="onIframeLoad"
        @load="onLoad"
        name="my-frame"
        width="100%"
        height="70vh"
        defer
      />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueIframe from 'vue-iframes'
import store from "@/store";

Vue.use(VueIframe)

export default {
  name: "TheIframePage.vue",
  data() {
    return {
      src: '',
      myIframe: '',
      loading: false
    }
  },
  props: {
    pageId: {
      type: String,
      required: true,
    },
    embeddedMode: {
      type: Boolean,
      default: false,
    },
    appConfig: {
      type: Object,
      default: null,
    },
    blockIndex: {
      type: Number,
      default: null,
    },
  },
  computed: {
    config() {
      return store.state.activeSidebarItem;
    },
    title(){
      return this.config?.title
    }
  },
  methods: {
    onLoad(frame) {
      this.myIframe = frame.contentWindow
    },
    onIframeLoad(){
      this.src = this.config?.pageblocks[0].src
      this.loading = this.src ? false : true
    }
  }
}
</script>

<style scoped lang="scss">
.page {
  width: 100%;
  height: 100%;

  & .tesIframe {
    width: 100%;
    height: 100%;

    & .x-component{
      @include scrollbars();
      overflow-y: auto;
    }
  }

}
</style>
